import { render } from "./CounterROIModal.vue?vue&type=template&id=b80d4f12&ts=true"
import script from "./CounterROIModal.vue?vue&type=script&lang=ts"
export * from "./CounterROIModal.vue?vue&type=script&lang=ts"

import "./CounterROIModal.vue?vue&type=style&index=0&id=b80d4f12&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__